import { render, staticRenderFns } from "./SupportContent.vue?vue&type=template&id=427c713e&"
import script from "./SupportContent.vue?vue&type=script&lang=js&"
export * from "./SupportContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports